import { render, staticRenderFns } from "./DoneGoToNextStep.vue?vue&type=template&id=b688cbd0&"
import script from "./DoneGoToNextStep.vue?vue&type=script&lang=js&"
export * from "./DoneGoToNextStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports